export const kindeConfig = {
  clientId: import.meta.env.VITE_KINDE_CLIENT_ID,
  domain: import.meta.env.VITE_KINDE_DOMAIN,
  redirectUri: import.meta.env.VITE_KINDE_REDIRECT_URI,
  logoutRedirectUri: import.meta.env.VITE_KINDE_LOGOUT_REDIRECT_URI,
  audience: import.meta.env.VITE_KINDE_AUDIENCE,
} as const;
